module.exports = __webpack_public_path__ + "static/media/opportunity_to_be_free.b0d4190c.mp4";